
class LanguageSwitcher {
    constructor() {
        this.languagesSelector = '.languages'
        this.languagesLinkSelector = this.languagesSelector + '__link'
        this.languagesDropdownSelector = this.languagesSelector + '__dropdown'
        this.switchers = document.querySelectorAll(this.languagesSelector)
        this.isInitialized = false
        this.init()
    }

    init() {
        if (this.isInitialized || this.switchers.length === 0) return

        this.bindEvents()
        this.isInitialized = true
    }

    bindEvents() {
        document.addEventListener('click', (e) => {
            const button = e.target.closest(this.languagesLinkSelector)
            if (button && button.closest(this.languagesSelector)) {
                this.toggleDropdown(button)
            }
        })

        document.addEventListener('click', (e) => {
            if (!e.target.closest(this.languagesSelector)) {
                this.closeAllDropdowns()
            }
        })

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeAllDropdowns()
            }
        })

        document.addEventListener('click', (e) => {
            const langLink = e.target.closest(this.languagesDropdownSelector + ' a')
            if (langLink) {
                setTimeout(() => {
                    this.closeAllDropdowns()
                }, 100)
            }
        })
    }

    toggleDropdown(button) {
        const switcher = button.closest(this.languagesSelector)
        const dropdownMenu = switcher.querySelector(this.languagesDropdownSelector)
        const chevron = switcher.querySelector('.chevron')

        if (!dropdownMenu) return

        const isOpen = button.classList.contains('show')

        this.closeAllDropdowns()

        if (!isOpen) {
            button.classList.add('show')
            if (dropdownMenu) {
                dropdownMenu.style.display = 'block'
                dropdownMenu.style.visibility = 'visible'
            }
            if (chevron) {
                chevron.style.transform = 'rotate(180deg)'
            }
        }
    }

    closeAllDropdowns() {
        this.switchers.forEach(switcher => {
            const button = switcher.querySelector(this.languagesLinkSelector)
            const dropdownMenu = switcher.querySelector(this.languagesDropdownSelector)
            const chevron = switcher.querySelector('.chevron')

            if (button) {
                button.classList.remove('show')
            }
            if (dropdownMenu) {
                dropdownMenu.style.display = 'none'
                dropdownMenu.style.visibility = 'hidden'
            }
            if (chevron) {
                chevron.style.transform = 'rotate(0deg)'
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new LanguageSwitcher()
})


function addToMobileMenu() {
    const headerMobileAdditional = document.querySelector(`${headerMenuClass}__mobile-addition`)
    if (headerMobileAdditional) {
        const menus = document.querySelectorAll(`${sidebarClass} .nav`)
        if (menus.length > 0) {
            menus.forEach(menu => {
                const clonedMenu = menu.cloneNode(true)
                headerMobileAdditional.appendChild(clonedMenu)
            })
            setTimeout(() => {
                const mobileLanguageSwitcher = new LanguageSwitcher()
                mobileLanguageSwitcher.switchers = headerMobileAdditional.querySelectorAll('.languages')
                if (mobileLanguageSwitcher.switchers.length > 0) {
                    mobileLanguageSwitcher.isInitialized = false
                    mobileLanguageSwitcher.init()
                }
            }, 100)
        }
    }
}

function toggleMenu() {
    if (typeof headerMenuClass !== 'undefined') {
        const headerMenuTogglerButton = document.querySelector(`${headerMenuClass} button`)
        if (headerMenuTogglerButton) {
            let clicked = false
            headerMenuTogglerButton.addEventListener('click', function () {
                headerMenuTogglerButton.classList.toggle('toggled')
                if (!clicked) {
                    addToMobileMenu()
                    clicked = true
                }
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', () => toggleMenu())
